import type { GetAIGeneratedTopicDetailsAction, InitTopicAction } from "domains/topicDetail/actionTypes";
import { TopicDetailType } from "domains/topicDetail/actionTypes";

export const initTopicDetail = (meta: InitTopicAction["meta"]): InitTopicAction => ({
  type: TopicDetailType.INIT,
  meta,
});

export const getAIGeneratedTopicDetails = (
  payload: GetAIGeneratedTopicDetailsAction["payload"],
): GetAIGeneratedTopicDetailsAction => ({
  type: TopicDetailType.GET_AI_GENERATED_DETAILS,
  payload,
});
